import { c } from "node_modules/vite/dist/node/types.d-AKzkD8vd";
import { ReactNode } from "react";

export default function Index() {
  return (
    <div className="flex h-full w-full flex-col items-center bg-[#E3DACC]">
      <div className="text-bold mt-20 font-FKScreamer text-[100px] uppercase">
        Tilgangur
      </div>
      <div className="mx-6 mt-20 flex max-w-[600px] flex-col items-center text-center text-2xl font-semibold sm:mx-10">
        <Paragraph>
          Heimurinn er ruglingslegur. Við búum við endalaust áreiti og kröfur um
          að líta vel út og koma óaðfinnanlega fram.
        </Paragraph>
        <Paragraph>
          Stöðugt er verið að ýta að okkur vörum sem lofa eilífri fegurð og
          lausnum við vandamálum, sem voru mögulega aldrei til staðar.
        </Paragraph>
        <Paragraph>
          Hvert sem litið er dynja á þér neikvæð skilaboð: „Þú ert með slæma
          húð! Léttu þig! Styrktu þig! Þú ert of mikið svona eða of lítið
          hinsegin!“
        </Paragraph>
        <StandOut>Endalaust</StandOut>
        <Paragraph>
          Það er nóg komið af þessu. Meira en nóg. Og einmitt þess vegna erum
          við hér. 
        </Paragraph>
        <Paragraph>
          Nola er hér fyrir þig. Til að hægja á, minnka suðið og finna samhljóm.
        </Paragraph>
        <Paragraph>
          Fyrir okkur er fegurð ekki eitthvað eitt, endanlegt markmið. Hún
          liggur í reynslunni. Ferðalaginu. Til þess að finna hana þarftu að
          leita inn á við. Þar og aðeins þar finnur þú þína sönnu útgeislun. Þar
          liggur fegurðin. Alltaf.
        </Paragraph>
        <Paragraph>
          Fegurðin á aldrei að koma á kostnað annarra. Hún á ekki að meiða eða
          skaða. Hvorki þig né nokkuð annað. Í okkar bókum er þetta algerlega
          skýrt.
        </Paragraph>
        <StandOut>Fegurð og kjaftæði eiga enga samleið</StandOut>
        <Paragraph>
          Í okkar augum er fegurðin helgur hluti af sjálfsmynd hvers og eins.
          Hún þrífst á ást, visku og umhyggju — hún streymir að innan og nærir
          húðina.
        </Paragraph>
        <Paragraph>
          Nola býður ykkur öll velkomin. Hér er enginn afsláttur gefinn af
          fegurðinni. Hún á aðeins skilið það besta.
        </Paragraph>
      </div>
    </div>
  );
}

const Paragraph = ({ children }: { children: ReactNode }) => (
  <div className="my-2">{children}</div>
);

const StandOut = ({ children }: { children: ReactNode }) => (
  <div className="my-6 font-FKScreamer text-[64px] font-semibold leading-[64px]">
    {children}
  </div>
);
